<app-custom-table-row class="table-row skeleton-row">
  <app-custom-table-cell
    class="table-cell main-label-cell sticky-main-cell-left">
    <div class="name">
      <div>
        <div
          class="person-name placeholder-pill"
          style="width: 150px; height: 19px"></div>
      </div>
    </div>
  </app-custom-table-cell>
  <app-custom-table-cell
    [style.width]="44 * days + 'px'"
    [class]="
      'table-cell skeleton-cell shadow-cells-' + getCappedDays()
    "></app-custom-table-cell>
</app-custom-table-row>
